import * as React from "react";
import {
  AutocompleteInput,
  Edit,
  EditProps,
  ReferenceInput,
  SimpleForm,
  useLocaleState,
} from "react-admin";

const MainPageEdit = (props: EditProps) => {
  const [locale] = useLocaleState();

  return (
    <Edit {...props} mutationOptions={{ meta: { fileUpload: true } }}>
      <SimpleForm style={{ display: "flex", width: "100%" }}>
        <ReferenceInput source="banner" reference="banners">
          <AutocompleteInput
            fullWidth
            label="mainPage.banner"
            optionText={`bannerTitle.${locale}`}
          />
        </ReferenceInput>

        <ReferenceInput source="about" reference="about">
          <AutocompleteInput
            fullWidth
            label="mainPage.about"
            optionText={`sectionTitle.${locale}`}
          />
        </ReferenceInput>

        <ReferenceInput source="benefits" reference="benefits">
          <AutocompleteInput
            fullWidth
            label="mainPage.benefits"
            optionText={`sectionTitle.${locale}`}
          />
        </ReferenceInput>

        <ReferenceInput source="popular" reference="popular">
          <AutocompleteInput
            fullWidth
            label="mainPage.popular"
            optionText={`sectionTitle.${locale}`}
          />
        </ReferenceInput>
      </SimpleForm>
    </Edit>
  );
};

export default MainPageEdit;
